<template>
    <div class="full-content has-header">
        <div class="content-container">
            <div class="content-header">
                <b-img class="img-logo" fluid :src="getLogo()"></b-img>
                <h1>{{ getService() }}</h1>
            </div>
            <div class="content-content">
                <b-row>
                    <div class="col-xl-12 col-ld-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-line">
                            <div class="form-group">
                                <label for="login" class="form-label ">Identifiant</label>
                                <input id="login" v-model="username"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-ld-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="form-line">
                            <div class="form-group has-icn" style="border-bottom: unset !important;">
                                <label for="password" class="form-label ">Mot de passe:</label>
                                <input
                                    id="password"
                                    v-on:keyup.enter="doLogin"
                                    v-model="password"
                                    :type="'password'"
                                />
                            </div>
                        </div>
                    </div>

                </b-row>
                <div class="form-line text-center">
                    <div class="form-btn primary" @click="doLogin()">Se Connecter</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuex from "vuex";
    import router from "../router/index.js";

    export default {
        name: "Login",
        data: () => ({
            username: "",
            password: "",
            return: "",
        }),
        methods: {
            getLogo() {
                return window.logo;
            },
            getService() {
                return window.commune;
            },
            toEnv() {
                router.push({name: "envs"});
            },
            ...Vuex.mapActions("Authentification", ["login"]),
            doLogin() {
                var user = {
                    username: this.username,
                    password: this.password,
                    // remember_me : false,
                };
                this.login(user);
            },
        },
        computed: {
            ...Vuex.mapGetters("Authentification", ["authStatus", "isAuthenticated"]),
            ...Vuex.mapGetters("Application", ['needReturn']),
            ident: {
                get: function () {
                    return this.login + "/" + this.password;
                },
                set: function (value) {
                    this.return = value;
                },
            }, //,
            // ...vuex.mapGetters('Dossiers', ['engagements'])
        },
    };
</script>

<style>
    @import "../styles/generic.css";
    @import "../styles/form.css";
    @import "../styles/style_form.css";
</style>
